import CONFIG from '@/config/config.ts';
import { RouteEnum } from '@/layouts/routes/Route.model.ts';

export const PATHS_NOT_REQUIRING_AUTHORIZATION: string[] = [
  RouteEnum.MAINTENANCE,
  RouteEnum.NOT_AUTHORIZED,
  RouteEnum.WAITING_FOR_APPROVAL,
  RouteEnum.LOGIN,
];

export const KEYCLOAK_REDIRECT_URL = CONFIG.HOST + '/' + import.meta.env.VITE_KEYCLOAK_REDIRECT_URL;
export const LOGIN_REDIRECT_URL = CONFIG.HOST + '/login';
